var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2.-Configuration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-Configuration/HR----02-Selected-image-",
    transform: "translate(-869.000000, -208.000000)",
    fill: "#4092F5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mbri-map-pin",
    transform: "translate(869.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,8.8 C1.7944,8.8 1.6272,8.9544 1.6064,9.16 L0.008,22.752 C-0.0752,23.4608 0.544,24 1.2048,24 L21.1952,24 C21.8552,24 22.4752,23.4608 22.392,22.752 L20.7936,9.16 C20.7312,8.6288 19.936,8.7232 19.9984,9.2528 L21.5984,22.8472 C21.6184,23.0184 21.4224,23.1992 21.1952,23.1992 L1.2048,23.1992 C0.9784,23.1992 0.7808,23.0184 0.8016,22.8472 L2.4016,9.252 C2.4336,9.012 2.2416,8.8 2,8.7992 L2,8.8 Z M11.2,3.2 C9.4376,3.2 8,4.6376 8,6.4 C8,8.1624 9.4376,9.6 11.2,9.6 C12.9624,9.6 14.4,8.1624 14.4,6.4 C14.4,4.6376 12.9624,3.2 11.2,3.2 Z M11.2,4 C12.5304,4 13.6,5.0696 13.6,6.4 C13.6,7.7304 12.5304,8.8 11.2,8.8 C9.8696,8.8 8.8,7.7304 8.8,6.4 C8.8,5.0696 9.8696,4 11.2,4 Z M11.2,0 C7.6704,0 4.8,2.8704 4.8,6.4 C4.8,8.94 6.0984,11.6824 7.504,13.82 C8.2056,14.8896 8.936,15.804 9.5656,16.464 C9.88,16.7936 10.1656,17.0584 10.4232,17.2512 C10.6792,17.4448 10.8712,17.6 11.1992,17.6 C11.5272,17.6 11.7192,17.4448 11.9752,17.2512 C12.2328,17.0592 12.5192,16.7936 12.8336,16.464 C13.4624,15.8048 14.1936,14.8896 14.896,13.82 C16.3024,11.6824 17.6,8.94 17.6,6.4 C17.6,2.8704 14.7296,0 11.2,0 Z M11.2,0.8 C14.2976,0.8 16.8,3.3024 16.8,6.4 C16.8,8.66 15.5824,11.3176 14.228,13.38 C13.5512,14.4104 12.8416,15.2952 12.2544,15.9112 C11.9616,16.2176 11.6968,16.46 11.4944,16.6136 C11.2504,16.792 11.0984,16.7608 10.9064,16.6136 C10.7032,16.46 10.4384,16.2176 10.1464,15.9096 C9.5584,15.2936 8.8488,14.4096 8.172,13.3792 C6.8176,11.3176 5.6,8.66 5.6,6.4 C5.6,3.3024 8.1024,0.8 11.2,0.8 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.636f0a5602e982d60fed21fe24b5addf.svg";
export { ForwardRef as ReactComponent };